import { render, staticRenderFns } from "./dota.vue?vue&type=template&id=031a83e8&scoped=true"
import script from "./dota.vue?vue&type=script&lang=js"
export * from "./dota.vue?vue&type=script&lang=js"
import style0 from "./dota.vue?vue&type=style&index=0&id=031a83e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a83e8",
  null
  
)

export default component.exports